<div *ngIf="error || (!configData && loaded)">
    <div style="
height: 100%;
width: 100%;
/* background-color: #7a3b3b; */
/* background-color: #f3f3f3; */
background-color: #542525;
position: absolute;
right: 0px;
bottom: 0px;
">
    </div>
    <div style="
height: 100%;
    width: 800px;
    background-color: #7a3b3b;
    position: absolute;
    border-bottom-left-radius: 100%;
    right: 170px;
    bottom: 70px;"></div>
    <div style="
height: 100%;
width: 800px;
background-color: #b1911d;
position: absolute;
border-bottom-left-radius: 100%;
right: 0px;
bottom: 0px;"></div>

    <div class="myDiv">
        <mat-card class="loginDiv" style="margin-bottom: 5px;">
            <div class="logosContainer">
                <div class="logo">
                    <h1>Hola!</h1>
                    <div>
                        Verifique que la dirección especificada (URL) es correcta y está completa. Verifique que está conectado a internet.
                    </div>

                </div>
            </div>

        </mat-card>
    </div>
</div>
<div *ngIf="configData">{{ configData.instance_name }}
    <router-outlet></router-outlet>
</div>